import styled from 'styled-components';

export const SectionGridContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 120px;
  margin-bottom: 32px;
  @media (max-width: 768px) {
    margin-top: 40px;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 32px;
  margin-top: 32px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
`;

export const CenterHeader = styled.div`
  text-align: center;
`;
